import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export type RequiredValidatorType = ValidationErrors | null;
export const getValidatorRequired = (): (control) =>
RequiredValidatorType => (control: AbstractControl): RequiredValidatorType => Validators.required(control);
